import { Component, OnInit } from "@angular/core";
import { clientConfig, appConfig } from "../../constant/app.constant";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"]
})
export class AppFooterComponent implements OnInit {
  tenantName: string = clientConfig.TENANTNAME.toLowerCase();
  showFooter: boolean = clientConfig.TENANTNAME.toLowerCase() != "tendam";
  centiroLogo: string = `${appConfig.NG_APP_ROOT}/assets/powered-by-centiro-logo/powered_by_Centiro.svg`;
  cobrandingLogo = `${appConfig.NG_APP_ROOT}/assets/co-branding/${clientConfig.TENANTNAME.toLowerCase()}/${clientConfig.TENANTNAME.toLowerCase()}.svg`;
  showCobranding: boolean = false;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.checkCobrandingLogoExists();
  }

  checkCobrandingLogoExists(): void {
    this.http.head(this.cobrandingLogo).subscribe(
        () => {
            this.showCobranding = true;
        },
        (error) => {
            this.showCobranding = false;
        }
    );
  }

  isDarkTheme(): boolean {
    return document.documentElement.style.getPropertyValue("--color-body-background") === "#262626";
  }
}
